import { ApiError } from '@funnels/types';

export function getApiErrors(apiErrors: Array<ApiError | null>) {
  return apiErrors.reduce<ApiError[]>((errorList: ApiError[], err) => {
    if (err && err.message) {
      errorList.push(err as ApiError);
    }
    return errorList;
  }, []);
}
